import css from "styled-jsx/css";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";

import "@mondaydotcomorg/monday-ui-components/dist/TilesList.css";

export const componentStyles = css.global`
  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .category-tiles-component {
      .tiles-list--wrapper {
        text-align: center;

        .tile-items--container {
          margin-top: 16px;
          margin-right: -12px;
          justify-content: center;

          .tile-item--container {
            margin: 6px 12px;

            .tile-item--wrapper {
              margin-top: 8px;
              width: calc(100vw / 2 - 40px);

              .tile-item--background {
                height: 52px;

                svg {
                  height: 32px;
                }
              }

              .tile-item--label {
                margin-top: 8px;
                font-size: 0.6875rem;
              }
            }
          }
        }
      }
    }
  }
`;
